export default {
    system: '颂明医疗数字病理云空间',
    body: {
        share: '分享',
        share_click: '点击分享',
        ctrl_c: '复制',
        close: '关闭',
        copy_success: '复制成功',
        copy_fail: '复制失败',
        error: '切片资源已损坏',
        export_all: '批量导出',
        export_success: '导出成功',
        export_fail: '导出失败',
        export_filename: '切片分享链接.xlsx',
        export_sheet: '切片列表',
        serial_no: '序号',
        slide_name: '切片名',
        slide_link: '切片链接'
    },
    setting: {
        title: '设置主目录',
        Current_directory: '当前主目录',
        set: '设为主目录',
        null: '暂无子目录'
    }
}
